import { createFileRoute } from '@tanstack/react-router';
import { InboxShell } from '@/components/inbox/InboxShell';

export const Route = createFileRoute('/_app/inbox/')({
  component: InboxPage,
});

function InboxPage() {
  return <InboxShell />;
}
